import React from 'react';
import Avatar from './AvatarDropdown';
import styles from './styles.module.css';

const GlobalHeaderRight = (props) => {
  const { theme, layout } = props;
  let className = styles.right;

  if (theme === 'dark' && layout === 'top') {
    className = `${styles.right}  ${styles.dark}`;
  }

  return (
    <div className={className}>
      <Avatar />
    </div>
  );
};

export default GlobalHeaderRight;
